<template>
	<div class="accordion-list">
		<slot name="items-empty-template" v-if="items.length <= 0" />

		<accordion-item
			v-for="(item, itemIndex) in items"
			:expanded="itemIndex === 0"
			:item="item"
			:itemIndex="itemIndex"
			:key="itemIndex"
			:showFooter="hasItemFooterTemplate"
		>
			<template slot="item-header-template" slot-scope="{ item, itemIndex }">
				<slot name="item-header-template" :item="item" :itemIndex="itemIndex" />
			</template>

			<template slot="item-body-template" slot-scope="{ item, itemIndex }">
				<slot name="item-body-template" :item="item" :itemIndex="itemIndex" />
			</template>

			<template slot="item-footer-template" slot-scope="{ item, itemIndex }">
				<slot name="item-footer-template" :item="item" :itemIndex="itemIndex" />
			</template>
		</accordion-item>
	</div>
</template>

<script>
import AccordionItem from './AccordionItem';

export default {
	components: {
		AccordionItem,
	},

	props: {
		items: {
			default: [],
			type: [Array, Object],
		},
	},

	computed: {
		hasItemFooterTemplate() {
			return !!this.$scopedSlots['item-footer-template'];
		},
	},
};
</script>
